<div>
    <span class="icon-span" (click)="visibleModal()">
        <app-icon ic="IcAddCircle" size="s" color="var(--color-primary-60)" (click)="editBtnAction()"></app-icon>
    </span>
</div>